import type { I18NMessages } from '@atlaskit/intl-messages-provider';

export type AsyncLanguageLoader = () => Promise<{ default: I18NMessages }>;
export type AsyncLanguages = Record<string, AsyncLanguageLoader>;

export const createFetchMessagesForLocale = (
	asyncLanguages: AsyncLanguages,
	defaultMessages: I18NMessages,
) => {
	return async (locale: string): Promise<I18NMessages> => {
		try {
			// Fallback to the generic locale if specified one is not found
			const languageLocale = locale in asyncLanguages ? locale : locale.split(/[-_]/)[0] || '';

			// Dynamic import of the locale file
			const localeMessages = await asyncLanguages[languageLocale]?.();

			return localeMessages?.default ?? defaultMessages;
		} catch (e) {
			// ignore
		}

		return defaultMessages;
	};
};
